<template>
  <div class="betslip-sticky" style="">
    <div v-if="eventObject">
      <div style="text-align: center" v-if="!isMobile()">
        <v-btn v-if="showTrackerBtn" v-on:click="showStatscorePlayer()" class="btn-submit-header"
          style="width: 42%; display: inline-block; text-align: center">Match Tracker</v-btn>
        <v-btn v-if="showStreamBtn" v-on:click="showImgPlayer()" class="btn-submit-header"
          style="width: 42%; display: inline-block; text-align: center">Live Stream</v-btn>
      </div>
      <div>
        <Statscore v-if="!isMobile() && showStatscore" :eventObject="eventObject"></Statscore>
        <Widget v-if="!isMobile() && showImg" :eventObject="eventObject"></Widget>
      </div>
    </div>
    <div id="betslipAnchor" class="betslip-container full-height betslip-hide-scroll">
      <v-tabs color="#4f2e7b" fixed-tabs @click="toggleBetSlip()">
        <v-tab class="betslip-tab" @click="toggleBetSlip()">
          Bet Slip
          <span id="bet-number-count" v-if="$store.getters.betSelection.length > 0"> ({{ $store.getters.betSelection.length
          }})</span>
        </v-tab>
        <v-icon id="toggleArrow" @click="toggleBetSlip()" style="text-align: right">{{ betSlipToggleIcon }}</v-icon>
      </v-tabs>
      <div id="betSlipToggleSwitch" class="betSlip">
        <div class="header">
          <template v-if="hasBets">
            <div v-for="(selection, index) in betSelections" :key="selection.marketId">
              <BetSlipItem :connection="connection" :betSelection="selection" :betSubmit="betSubmitSingle"
                :removeBet="removeBet" :calculatePayout="calculatePayout" :betLeg="index + 1"></BetSlipItem>
            </div>
            <MultiBetItem :betSelections="betSelections" :betSubmit="betSubmitMultiple" v-if="
              !hasRelatedEvents() && betSelections && betSelections.length > 1
            "></MultiBetItem>
          </template>
          <div v-else class="empty-message">
            Add selections to your bet slip
          </div>
        </div>
        <div class="footer" v-if="betSelections !== null">
          <v-select v-if="hasBets" v-model="selectedOddsChange" class="odds-select" :items="oddsChange"
            v-on:change="setOddsPreference" dark dense color="gold"></v-select>
          <div class="minStakeClearWrapper" v-if="$store.getters.betSelection.length > 0">
            <div class="minStake">*Min. stake R1.00</div>
            <div class="remove-all-bets">
              <a @click="removeAllBets()" v-if="$store.getters.betSelection.length > 0"
                :class="{ disabledClick: $store.getters.isSubmitting }">
                <i class="material-icons close-bet">delete_outline</i>
                <span class="clear-all-bets">Remove All</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HubConnection } from "@aspnet/signalr";
import BetSlipItem from "./BetSlipItem.vue";
import MultiBetItem from "./MultiBetItem.vue";
import Statscore from "./Statscore.vue";
import Widget from "./Widget.vue";
import BetSlipApi from "@/api/BetSlip";
import { isNullOrUndefined } from "util";
import StreamAPI from "../api/streaming";

export default {
  name: "BetSlip",
  components: {
    BetSlipItem,
    MultiBetItem,
    Statscore,
    Widget,
  },
  data() {
    return {
      showStatscore: true,
      showImg: false,
      showTrackerBtn: false,
      showStreamBtn: false,
      statscoreFixtureId: 0,
      betSlipToggleIcon: "keyboard_arrow_right",
      betSuccessResponse: "",
      betErrorResponse: "",
      totalOdds: 0.0,
      totalStake: 0.0,
      totalPayout: 0.0,
      error: false,
      timeout: false,
      countdown: 10,
      submitText: "Submit Bet",
      oddsChange: [
        "Accept any odds change",
        "Accept higher odds change",
        "Don't accept odds changes",
      ],
    };
  },
  props: {
    connection: HubConnection,
    eventObject: Object,
  },
  mounted() { },
  watch: {
    eventObject: {
      handler(newVal, old) {
        if (old != null) {
          if (old.fixtureId !== newVal.fixtureId) {
            this.getMappedEventData(newVal.fixtureId);
          }
        } else {
          this.getMappedEventData(newVal.fixtureId);
        }
      },
    },

  },
  filters: {
    currency(amount) {
      const amt = Number(amount);
      return (
        (amt && amt.toLocaleString(undefined, { maximumFractionDigits: 2 })) ||
        "0.00"
      );
    },
  },
  computed: {
    betSelections() {
      let selection = this.$store.getters.betSelection;
      if (selection !== undefined && selection.length > 0) {
        return selection;
      } else {
        return "";
      }
    },
    hasBets() {
      let selection = this.$store.getters.betSelection;
      if (selection !== undefined && selection.length > 0) {
        return true;
      }
      return false;
    },
    punterId() {
      return this.$store.getters.punterId;
    },
    sport() {
      let selection = this.betSelections;
      return selection !== undefined && selection.length > 0
        ? selection[0] && selection[0].sport
        : "";
    },
    selectedOddsChange: {
      get: function () {
        return this.$store.getters.selectedOddsChange;
      },
      set: function (value) {
        this.$store.dispatch("setselectedOddsChange", value);
      },
    },
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    onChildClick(value) {
      this.fromChild = value;
    },
    toggleBetSlip() {
      var x = document.getElementById("betSlipToggleSwitch");
      if (x.style.display === "none") {
        this.betSlipToggleIcon = "keyboard_arrow_right";
        x.style.display = "inline-block";
      } else {
        this.betSlipToggleIcon = "keyboard_arrow_down";
        x.style.display = "none";
      }
    },
    removeAllBets() {
      for (var i = 0; i < this.betSelections.length; i++) {
        this.connection.invoke(
          "UnSubscribe",
          this.betSelections[i].marketDetailId + "betSlip"
        );
      }
      this.$store.dispatch("removeAllBets");
      this.$store.dispatch("setMultipleSubmission", {
        success: false,
        error: false,
        errorMessage: "",
        submitting: false,
        accepted: false,
      });
      this.connection.invoke("UnSubscribe", this.marketDetailId + "betSlip");
    },
    setOddsPreference(value) {
      this.$store.dispatch("setselectedOddsChange", value);
    },
    betSubmitSingle(betSelection) {
      const betCriteria = this.initializeBetCriteria();
      betCriteria.punterId = this.punterId;
      betCriteria.priceChangeDrift = this.getPriceDrift(betCriteria);
      //Submit Single
      if (isNullOrUndefined(betSelection)) {
        this.$store.dispatch("setSelectionSubmission", {
          marketDetailId: betSelection.marketDetailId,
          ticketNumber: null,
          success: false,
          error: true,
          errorMessage: "No bet selected",
          submitting: false,
        });
        return;
      }
      betCriteria.betLegs.push(betSelection);
      betCriteria.betLegs[0].betleg.odds = betSelection.betleg.odds;
      betCriteria.totalOdds = betSelection.betleg.odds;
      betCriteria.betLegs[0].betleg.stake = betSelection.betleg.stake;
      betCriteria.totalStake = betSelection.betleg.stake;
      betCriteria.betLegs[0].betleg.payout =
        betSelection.betleg.stake * betSelection.betleg.odds;
      betCriteria.totalPayout = betCriteria.betLegs.payout;

      if (this.$store.getters.accessToken !== null) {
        BetSlipApi.submitBet(betCriteria)
          .then((data) => {
            this.$store.dispatch("storeSubmitBetRequestId", '');
            if (data.responseType === 1) {
              this.$store.dispatch(
                "setTicketNumber",
                data.responseObject[0].ticketNumber
              );

              this.$store.dispatch("setSelectionSubmission", {
                marketDetailId: betSelection.marketDetailId,
                ticketNumber: data.responseObject[0].ticketNumber,
                success: true,
                error: false,
                errorMessage: "",
                submitting: false,
              });
            } else {
              if (
                (data.responseObject &&
                  data.responseObject[0].returnID === 6) ||
                (data.responseObject && data.responseObject[0].returnID === 13)
              ) {
                let errorMsg = data.responseObject[0].returnMessage;
                let pos = errorMsg.indexOf(",");
                let displayMsg = errorMsg.substring(pos + 1);
                this.$store.dispatch("setSelectionSubmission", {
                  marketDetailId: betSelection.marketDetailId,
                  success: false,
                  error: true,
                  errorMessage: displayMsg,
                  submitting: false,
                });
              }
              this.$store.dispatch("setSelectionSubmission", {
                marketDetailId: betSelection.marketDetailId,
                success: false,
                error: true,
                errorMessage: data.responseMessage,
                submitting: false,
              });
            }
          })
          .catch((error) =>
            this.$store.dispatch("setSelectionSubmission", {
              marketDetailId: betSelection.marketDetailId,
              success: false,
              error: true,
              errorMessage: error,
              submitting: false,
            })
          )
          .finally(() => { });
      } else {
        this.$store.dispatch("setSelectionSubmission", {
          marketDetailId: betSelection.marketDetailId,
          success: false,
          error: true,
          errorMessage: "You need to be logged in to submit a bet",
          submitting: false,
        });
      }
    },
    betSubmitMultiple(betSelections) {
      let betCriteria = this.initializeBetCriteria();
      betCriteria.punterId = this.punterId;
      betCriteria.priceChangeDrift = this.getPriceDrift(betCriteria);
      if (isNullOrUndefined(betSelections)) {
        this.$store.dispatch("setMultipleSubmission", {
          success: false,
          error: true,
          errorMessage: "No bets selected",
          submitting: false,
        });
        return;
      }
      const multipleInfo = this.$store.getters.getMultipleTotals;
      betCriteria.totalOdds = multipleInfo.multipleTotals.totalOdds;
      betCriteria.totalStake = multipleInfo.multipleTotals.totalStake;
      betCriteria.totalPayout = multipleInfo.multipleTotals.totalPayout;
      betCriteria.betLegs = betSelections;
      for (let i = 0; i < betCriteria.betLegs.length; i++) {
        betCriteria.betLegs[i].betleg.betLegNumber = i + 1;
      }
      if (this.$store.getters.accessToken !== null) {
        BetSlipApi.submitBet(betCriteria)
          .then((data) => {
            this.$store.dispatch("storeSubmitBetRequestId", '');
            if (data.responseType === 1) {
              this.$store.dispatch(
                "setTicketNumber",
                data.responseObject[0].ticketNumber
              );

              this.$store.dispatch("setMultipleSubmission", {
                success: true,
                ticketNumber: data.responseObject[0].ticketNumber,
                error: false,
                errorMessage: "",
                submitting: false,
              });
              // this.ticketNo = data.responseObject[0].ticketNumber;

              this.$store.dispatch("updateMultipleTotals", {
                totalStake: 0,
                totalOdds: 0,
                totalPayout: null,
              });
            } else {
              if (this.$store.getters.getMultipleError) {
                this.$store.dispatch("setMultipleSubmission", {
                  success: false,
                  error: false,
                  errorMessage: "",
                  submitting: false,
                });
              }
              this.$store.dispatch("setMultipleSubmission", {
                success: false,
                error: true,
                errorMessage: data.responseMessage,
                submitting: false,
              });
            }
          })
          .catch((error) => {
            if (this.$store.getters.getMultipleError) {
              this.$store.dispatch("setMultipleSubmission", {
                success: false,
                error: false,
                errorMessage: "",
                submitting: false,
              });
            }
            this.$store.dispatch("setMultipleSubmission", {
              success: false,
              error: true,
              errorMessage: error,
              submitting: false,
            });
          })
          .finally(() => { });
      } else {
        if (this.$store.getters.getMultipleError) {
          this.$store.dispatch("setMultipleSubmission", {
            success: false,
            error: false,
            errorMessage: "",
            submitting: false,
          });
        }
        this.$store.dispatch("setMultipleSubmission", {
          success: false,
          error: true,
          errorMessage: "You need to be logged in to submit a bet",
          submitting: false,
        });
      }
    },
    showImgPlayer() {
      this.showImg = true;
      this.showStatscore = false;
    },
    showStatscorePlayer() {
      this.showStatscore = true;
      this.showImg = false;
    },
    removeBet(betSelection) {
      this.$store.dispatch("removeBet", betSelection.marketDetailId);
      this.$store.dispatch("setMultipleSubmission", {
        success: false,
        error: false,
        errorMessage: "",
        submitting: false,
        accepted: false,
      });
      this.$store.dispatch("setAcceptedChanges", betSelection);
      this.connection.invoke(
        "UnSubscribe",
        betSelection.marketDetailId + "betSlip"
      );
    },
    hasRelatedEvents() {
      return this.$store.getters.hasRelatedEvents;
    },
    calculatePayout(stake, odds) {
      if (stake && odds > 0) return stake * odds;
      return 0;
    },

    getPriceDrift(betCriteria) {
      betCriteria.priceChangeDrift = this.$store.getters.selectedOddsChange;
      if (betCriteria.priceChangeDrift === this.oddsChange[0]) {
        betCriteria.priceChangeDrift = 3;
      } else if (betCriteria.priceChangeDrift === this.oddsChange[1]) {
        betCriteria.priceChangeDrift = 2;
      } else if (betCriteria.priceChangeDrift === this.oddsChange[2]) {
        betCriteria.priceChangeDrift = 1;
      }
      return betCriteria.priceChangeDrift;
    },
    initializeBetCriteria() {
      return {
        punterId: -1,
        totalOdds: 0.0,
        totalStake: 0.0,
        totalPayout: 0.0,
        priceChangeDrift: 0,
        betLegs: [],
      };
    },
    getMappedEventData(fixtureId) {
      StreamAPI.getStreamingEvent(fixtureId)
        .then((data) => {
          if (data.responseObject) {
            this.showStreamBtn = true;
            this.showTrackerBtn = true;
          } else {
            this.showStreamBtn = false;
            this.showTrackerBtn = false;
            this.showStatscore = true;
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-submit-header {
  width: 100%;
  margin-right: 16px;
  /*margin: 16px 0px;*/
  line-height: 4px;
  /*display: inline-block;*/
  font-weight: 400;
  font-size: 10px;
  color: black;
  background-color: #8064E7 !important;
  border-radius: 0.5rem;
}

.video-js .vjs-tech {
  width: 90%;
  height: 300px;
}

.clear-all-bets {
  color: red;
  font-weight: 750;
}

.minStakeClearWrapper {
  display: flex;
  width: 100%;
}

.material-icons {
  color: red;
  font-weight: bolder;
  position: relative;
  font-size: 18px;
}

.close-bet {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  /*color: #96999b !important;*/
  right: 2px !important;
  font-size: 16px;
  display: inline;
  top: 3px;
  font-weight: 500;
}

.betslip-container {
  /*position: fixed;*/
  font-family: "Poppins";
  font-weight: 600;
}

.betslip-btn {
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
}

.betslip-tab {
  font-size: 16px;
  font-weight: 300;
  text-transform: uppercase;
  padding: 7px;
  color: #fff;
  border: 0px;
  margin-bottom: 0px;
  background: url("../assets/img/betslip-icon.svg") no-repeat center left;
  padding-left: 28px;
  background-color: #8064E6;
  width: 100%;
}

.betslip-tab .v-tabs__item {
  justify-content: left !important;
}

.betslip-tab a {
  cursor: default !important;
}

.betslip-item {
  color: #efefef;
  font-size: 12px;
  line-height: 19px;
  font-weight: normal;
}

button {
  text-align: right;
}

.currency {
  padding: 0 10px 0 5px;
}

.total-stake,
.currency {
  color: #ddd;
  line-height: 29px;
  font-size: 13px;
}

.empty-message {
  color: #000000;
  font-size: 15px;
  text-align: center;
  line-height: 18px;
  padding: 20px 10px 20px 10px;
  background-color: #fff;
  font-weight: normal;
  cursor: default;
  opacity: 1;
}

.odds-container {
  border-right: none;
  display: table-cell;
  position: relative;
}

.expanded .place-bet {
  display: inline-block;
  min-width: 45%;
  padding: 5px 5px 5px 0;
}

.remove-column {
  display: table-cell;
}

.remove-header {
  position: relative;
  background-color: #2b2b2b;
  padding: 0 10px 0 10px;
  text-align: left;
}

.expanded .selection {
  padding-bottom: 12px;
}

.primary--text {
  color: #ddd !important;
}

.selection {
  display: table-cell;
  vertical-align: top;
  width: 100%;
}

.stake {
  font-weight: 100;
}

.footer {
  background-color: #fff;
  position: relative;
  font-size: 0;
}

ul {
  margin: 0;
  padding: 0;
  font-size: 0;
}

li {
  list-style: none;
}

.betSlip {
  background-color: #fff;
  padding: 0px;
  display: block;
  width: 100%;
}

::placeholder {
  color: #fff;
}

:-ms-input-placeholder {
  color: #fff;
}

::-ms-input-placeholder {
  color: #fff;
}

.application--wrap {
  min-height: 100% !important;
}

.remove-all-bets {
  color: #929292 !important;
  font-size: 12px;
  position: relative;
  text-align: center;
  font-weight: normal;
  margin-top: -18px;
  padding-bottom: 10px;
  width: 50%;
}

.remove-all-bets a {
  width: 100%;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  padding: 5px 10px;
  display: inline-block;
  cursor: pointer;
}

.remove-all-bets a:hover {
  /*background-color: #bf0430;*/
}

.removeAllBtn {
  pointer-events: none;
  cursor: default;
}

.removeAllBtn:hover {
  background-color: #424242;
}

.full-height {
  overflow: hidden auto;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100vh;
}

.odds-select {
  margin-top: 5px;
}

.mt16 {
  margin-top: 16px !important;
}

.footer .v-input {
  font-size: 12px;
}

.header+.minStake {
  color: #929292 !important;
  font-size: 12px;
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
  font-weight: normal;
  margin-top: -12px;
  padding-bottom: 10px;
  width: 50%;
}

.minStake {
  color: #929292 !important;
  font-size: 12px;
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
  font-weight: normal;
  margin-top: -12px;
  padding-bottom: 10px;
  width: 50%;
}

#betslipAnchor #toggleArrow {
  position: fixed;
  right: 0px;
  top: 0px;
  background-color: #8064E6;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 3px;
  padding-right: 3px;
  color: #fff !important;
}

#bet-number-count {
  margin-left: 8px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: #8064E6;
  border: 0px solid #666;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  padding-top: 2px;
  padding-right: 1px;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.betslip-hide-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE and Edge */
.betslip-hide-scroll {
  -ms-overflow-style: none;
}

@media (max-width: 959px) {

  /* Hide scrollbar for Chrome, Safari and Opera */
  .betslip-hide-scroll::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE and Edge */
  .betslip-hide-scroll {
    -ms-overflow-style: none;
  }

  .betslip-sticky {
    border: 2px solid white;
    border-radius: 22px;
  }

  .betslip-tab {
    font-size: 16px;
    font-weight: 300;
    text-transform: uppercase;
    padding: 7px;
    color: #fff;
    border: 0px;
    margin-bottom: 0px;
    background: url("../assets/img/betslip-icon.svg") no-repeat center left;
    padding-left: 28px;
    background-color: #8064E6;
    position: absolute;
    display: block;
    justify-content: flex-start;
  }

  .betslip-tab a.v-tabs__item {
    justify-content: left;
  }
}
</style>
